import React from 'react'
import { useNavigate } from 'react-router-dom'
import './NotificationButton.css'

export default function DirectMessagesButton({ className = '' }) {
  const navigate = useNavigate()

  return (
    <button
      type="button"
      className={`notif-btn ${className}`.trim()}
      onClick={() => navigate('/messages')}
      title="Direct messages"
    >
      <span className="notif-btn-icon">✉</span>
      <span className="notif-btn-label">Direct Messages</span>
    </button>
  )
}
